import { useState } from 'react';
import FromLogin from './FromLogin';
import ForgetPasspord from './ForgetPasspord';
import './login.css';

const LoginForm = () => {
    const [forgetPasspord, setForgetPasspord] = useState(false);

    return (
        <div className="login-container">

            {
                forgetPasspord 
                ? 
                <ForgetPasspord
                setForgetPasspord={setForgetPasspord}
                />
                :
                <FromLogin
                setForgetPasspord={setForgetPasspord}
                />
            }
        </div>
    );
};

export default LoginForm;